const history = {
	state: {
		search: [],
		autoComplete: []
	},
	mutations: {
		'SET_SEARCH': (state, search) => {
        	state.search = search
        },
		'SET_AUTOCOMPLETE': (state, autoComplete) => {
        	state.autoComplete = autoComplete
        }
	}
}

export default history


// WEBPACK FOOTER //
// ./src/store/modules/history.js